import { consoleApiSlice } from "./consoleApiSlice";

export const consoleIssuesApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createConsoleIssue: builder.mutation({
      query: ({ scanId, issue }) => ({
        url: `/issues/${scanId}`,
        method: "POST",
        body: issue,
      }),
      invalidatesTags: ["Issues"],
    }),
    upsertConsoleIssue: builder.mutation({
      query: ({ scanId, issue }) => ({
        url: `/issues/upsert/${scanId}`,
        method: "POST",
        body: issue,
      }),
      invalidatesTags: ["Issues"],
    }),
    updateConsoleIssue: builder.mutation({
      query: ({ scanId, issue_content }) => ({
        url: `/issues/${scanId}`,
        method: "PUT",
        body: issue_content,
      }),
      invalidatesTags: (result, error, { issueId }) => [{ type: "Issues", id: issueId }, "Issues"],
    }),
    deleteConsoleIssue: builder.mutation({
      query: (issueId) => ({
        url: `/issues/${issueId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Issues"],
    }),
  }),
});

export const {
  useCreateConsoleIssueMutation,
  useUpdateConsoleIssueMutation,
  useDeleteConsoleIssueMutation,
  useUpsertConsoleIssueMutation,
} = consoleIssuesApiSlice;
